/**
 * Unauthorized Access Page
 * 
 * Displayed when user tries to access a route they don't have permission for
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Unauthorized.css';

const Unauthorized = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="unauthorized-container">
      <div className="unauthorized-card">
        <div className="unauthorized-icon">🚫</div>
        
        <h1 className="unauthorized-title">
          Access Denied
        </h1>
        
        <p className="unauthorized-message">
          You don't have permission to access this page.
        </p>
        
        {user && (
          <div className="unauthorized-info">
            <p>
              <strong>Your role:</strong> {user.role}
            </p>
            <p>
              This page requires administrator privileges. If you believe you should 
              have access, please contact your system administrator.
            </p>
          </div>
        )}
        
        <div className="unauthorized-buttons">
          <button 
            onClick={handleGoBack}
            className="btn btn-secondary unauthorized-btn"
          >
            Go Back
          </button>
          <button 
            onClick={handleGoHome}
            className="btn btn-primary unauthorized-btn"
          >
            Go to Home
          </button>
        </div>
        
        <p className="unauthorized-footer">
          All unauthorized access attempts are logged for security auditing.
        </p>
      </div>
    </div>
  );
};

export default Unauthorized;

